export default [
  {
    description: 'Default',
  },
  {
    description: 'Promotion Price Free of charge',
    price: {
      promotion: {
        amount: 0,
        currency: 'EUR',
        priceDisplay: null,
        value: '0',
      },
    },
  },
  {
    description: 'With priceInformation',
    texts: {
      priceInformation: 'xyz xyz <b>Price Information</b> xyz xyz xyz',
    },
  },
  {
    description: 'With PromotionOverrideText',
    texts: {
      promotionPriceOverrideText: 'foo bar foo bar <b>promotionPriceOverrideText</b> foo bar foo bar',
    },
  },
  {
    description: 'With EMPTY PromotionOverrideText',
    texts: {
      promotionPriceOverrideText: '',
    },
  },
  {
    description: 'No Price Promotion',
    price: {
      promotion: null,
    },
  },
  {
    description: 'No Price Promotion durationFactor (and no Promotion.setupPrice)',
    price: {
      promotion: {
        durationFactor: null,
        promotionEnd: '31.12.2019',
        setupPrice: null,
      },
    },
  },
  {
    description: 'No Price Promotion durationFactor (BUT WITH Promotion.setupPrice)',
    price: {
      promotion: {
        durationFactor: null,
        promotionEnd: '31.12.2019',
      },
    },
  },
  {
    description: 'PromotionEnd (and durationFactor: should override!)',
    price: {
      promotion: {
        promotionEnd: '31.12.2019',
      },
    },
  },
  {
    description: 'Price Promotion durationFactor = 3',
    price: {
      promotion: {
        durationFactor: 3,
      },
    },
  },
  {
    description: 'Price Promotion durationFactor = 15, chargingIntervalFactor = 3, chargingIntervalUnit = 2 (Days), promotion unit = 6 (Minutes)',
    price: {
      chargingIntervalUnit: 1,
      chargingIntervalFactor: 3,
      promotion: {
        durationFactor: 15,
        durationUnit: 6,
      },
    },
  },
  {
    description: 'promotionTypeOptin = true',
    promotionTypeOptin: true,
  },
  {
    description: 'With regularPriceOverrideText',
    texts: {
      regularPriceOverrideText: 'foo bar foo bar <b>regularPriceOverrideText</b> foo bar',
    },
  },
  {
    description: 'With EMPTY regularPriceOverrideText',
    texts: {
      regularPriceOverrideText: '',
    },
  },
  {
    description: 'No Promotion setupPrice',
    price: {
      promotion: {
        setupPrice: null,
      },
    },
  },
  {
    description: 'No setupPrice',
    price: {
      setupPrice: null,
    },
  },
  {
    description: 'No setupPrice and no Promotion setupPrice',
    price: {
      setupPrice: null,
      promotion: {
        setupPrice: null,
      },
    },
  },
  {
    description: 'No setupPrice and no Promotion',
    price: {
      setupPrice: null,
      promotion: null,
    },
  },
  {
    description: 'EMPTY minimumCommitmentPeriodOverrideText',
    texts: {
      minimumCommitmentPeriodOverrideText: '',
    },
  },
  {
    description: 'With minimumCommitmentPeriodOverrideText',
    texts: {
      minimumCommitmentPeriodOverrideText: 'foo bar xyz <b>minimumCommitmentPeriodOverrideText</b> foo bar xyz',
    },
  },
  {
    description: 'minimumCommitmentPeriodFactor = 1',
    price: {
      minimumCommitmentPeriodFactor: 1,
    },
  },
  {
    description: 'minimumCommitmentPeriodFactor = 0',
    price: {
      minimumCommitmentPeriodFactor: 0,
    },
  },
  {
    description: 'minimumCommitmentPeriodUnit = 1',
    price: {
      minimumCommitmentPeriodUnit: 1,
    },
  },
  {
    description: 'With minimumCommitmentPeriodText',
    texts: {
      minimumCommitmentPeriodText: 'foo bar <b>minimumCommitmentPeriodText</b> xyz',
    },
  },
  {
    description: 'With beforeOptinInfoText',
    texts: {
      beforeOptinInfoText: 'foo bar <b>beforeOptinInfoText</b> xyz',
    },
  },
  {
    description: 'price is null (ACE)',
    price: null,
  },
  {
    description: 'With chargingIntervalOverrideText (simple)',
    price: {
      setupPrice: null,
      promotion: null,
      chargingIntervalFactor: 0,
      chargingIntervalUnit: 0,
      minimumCommitmentPeriodFactor: 0,
      chargingIntervalOverrideText: 'monatlich',
    },
  },
  {
    description: 'With chargingIntervalOverrideText (complex)',
    price: {
      chargingIntervalFactor: 0,
      chargingIntervalUnit: 0,
      chargingIntervalOverrideText: 'monatlich',
    },
  },
  {
    description: 'One-Time-Subscription',
    price: {
      setupPrice: null,
      promotion: null,
    },
    subscriptionType: 2,
  },
];
